/**
 * created by lei lei on 2020/6/1
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {Col, Row, Table, Empty, Spin, Modal} from "antd";
import { Link } from "react-router-dom";
import {formatDate, permissionCheck, uuid} from "../../../../utils";
import {
    myReviewGridData,
    myMessageGridData, postPublic, setReadMessageStatus, getUnreadCount, changZykSearchText, getUnReadMessageCount,
} from '../../../../actions'
import { connect } from "react-redux";
import MessageNotification, { MessageNotificationModal } from '../../../../components/MessageNotification'
import './myMessage.scss'
import moreImg from "../commImg/diandiandian.png";
import Card from '../../../components/card/Card'
import {Scrollbars} from "react-custom-scrollbars";
import {getNotificationById} from "../../../../actions/messageNotificationList";

/* global layer */
class MyMessage extends Component {
    static defaultProps = {}
    static propTypes = {}

    constructor(props) {
        super(props);
        this.state = {
            myMessageData: [],
            loading: true,
            modalVisible: false,
            modalMessageListVisible: false,
            messageDetail: null,
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        // window.addEventListener('resize', this.resize.bind(this));
        // this.lastLoginLog();
        let that = this;
        var timeUpdate = setInterval(function () {
            if (that.props.currentUser) {
                clearInterval(timeUpdate)
                let param = that.props.currentUser;

                myMessageGridData(param, that.updateMyMessageGrid.bind(that))
            }

        }, 400)
    }
    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }
    updateMyMessageGrid(myMessageData) {
        let resultData = [];
        if(myMessageData.code === 0 ){
            if(myMessageData.count > 7){
                resultData = myMessageData.data.slice(0,8)
            } else {
                resultData = myMessageData.data.slice(0,8)
            }
        }

        this.setState({
            myMessageData: resultData,
            loading: false,

        })
    }

    render() {

        const { myMessageData, loading } = this.state;
        let isAuth = permissionCheck("pms:myMessage:viewAll");//是否展示我的消息
        if(!isAuth){
            return <div></div>
        }
        return (
            <Card title="我的消息" style={{ marginTop: '20px' }} showMore={true} moreClick={ () => {this.showMessageList()/*window.location.hash = '/xiaoxi/list'*/}}>
                <div className="my-message">
                    {
                        loading ? <div className="center"><Spin></Spin></div> : (myMessageData.length === 0 ? <div className="center"><Empty /></div> :
                            <div className="my-message-content">
                                {
                                    myMessageData.map((item, index) => {
                                        if(index<8){
                                            return(
                                                <div className="item" key={index} style={{display:"flex"}} onClick={() => { this.checkMyMessage(item) }}>
                                                    <div  style={{overflow: 'hidden',width:428,cursor:'pointer',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap'}}  title={item.title}>{item.title}</div>
                                                    <div style={{width:150}}>{item.createTime ? formatDate(item.createTime.time) : ''}</div>
                                                </div>
                                            )
                                        }
                                    })
                                }
                                {this.state.messageDetail &&
                                <MessageNotificationModal modalVisible={this.state.modalVisible}
                                                          onOk={this.onOk}
                                                          onCancel={this.onCancel}
                                                          messageDetail={this.state.messageDetail} />
                                }
                                <Modal
                                    title="消息列表"
                                    centered
                                    width={1000}
                                    visible={this.state.modalMessageListVisible}
                                    onOk={this.onMessageListOk}
                                    onCancel={this.onMessageListOk}
                                >
                                    <Scrollbars autoHeight autoHeightMax={500}>
                                        <MessageNotification showTitle={false}/>
                                    </Scrollbars>
                                </Modal>
                            </div> )
                    }
                </div>
            </Card>
        )
    }
    //我的消息，行点击事件
    checkMyMessage(recorde) {
        if(recorde.noticficationId > 0){
            getNotificationById(recorde.noticficationId,res=>{
                if(res){
                    recorde.newTitle=res;
                    this.setState({modalVisible: true,messageDetail: recorde});
                }
            })
        }else{
            this.setState({modalVisible: true,messageDetail: recorde})
        }

        //表示消息已读取的状态
        let param = {
            "messageId": recorde.id
        }
        //点击查看后，设置消息为已读状态；
        setReadMessageStatus(param, this.callSetReadMessageStatus.bind(this))
    }

    showMessageList = () => {
        this.setState({modalMessageListVisible: true})
    }

    reloadMessageData = () => {
    }

    onMessageListOk = () => {
        this.setState({modalMessageListVisible: false})
    }

    onMessageListCancel = () => {
        this.setState({modalMessageListVisible: false})
    }

    onOk = () => {
        this.setState({modalVisible: false, messageDetail: null})
    }
    onCancel = () => {
        this.setState({modalVisible: false, messageDetail: null})
    }

        callSetReadMessageStatus(data) {
        if (data) {
            if (data) {
                let param = this.props.currentUser;
                myMessageGridData(param, (data) => {
                    //console.log(data)
                    this.setState({ myMessageData: data.data })
                })

                //刷新未读消息红点；
                getUnreadCount({}, (data) => {
                    if (data.status === 200) {
                        this.props.getUnReadMessageCount(data.data.count);
                    }
                })
            }
        }
    }

}
function mapStateToProps(state) {
    return {
        currentUser: state.systemReducer.currentUser,
    }
}
function mapStateToMethod(dispatch) {
    return {
        getUnReadMessageCount: function (messageCount) {
            return dispatch(getUnReadMessageCount(messageCount));
        }
    }
}
export default connect(mapStateToProps)(MyMessage);